import { OperationDetailsRs } from '@root/api/ump-ewallet'
import { parseAmount } from '@shared/lib'

export const getOperationDetailsFee = (
  operationDetails: OperationDetailsRs,
  isCardPayment: boolean | undefined,
  isPubg: boolean,
  isTopUpWithPercentFeeService: boolean,
  isNonTopUpServiceDenomation: boolean
) => {
  if (isCardPayment) {
    return operationDetails?.amount?.fee ?? '0'
  }

  if (isPubg || isTopUpWithPercentFeeService) {
    return 0
  }

  if (isNonTopUpServiceDenomation) {
    return parseAmount(operationDetails?.amount?.fee ?? 0) - 50
  }

  return operationDetails?.amount?.fee ?? '0'
}
